import type { HTMLAttributes } from "react";
import { type VariantProps } from "tailwind-variants";

import { getInitials, tv } from "@/lib/utils";

const avatarVariants = tv({
  base: "inline-flex shrink-0 items-center justify-center rounded-full bg-primary-subdued text-primary font-semibold",
  variants: {
    size: {
      xs: "h-6 w-6 text-[10px]",
      sm: "h-8 w-8 text-xs",
      md: "h-10 w-10 text-sm",
      lg: "h-14 w-14 text-base",
      xl: "h-20 w-20 text-2xl",
    },
  },
  defaultVariants: {
    size: "md",
  },
});

type Props = HTMLAttributes<HTMLDivElement> &
  VariantProps<typeof avatarVariants> & {
    initials?: string;
  };

export const Avatar: React.FC<Props> = ({
  initials,
  size,
  className,
  children,
  ...props
}) => {
  const label = initials ? getInitials(initials) : "?";
  return (
    <div aria-hidden className={avatarVariants({ size, className })} {...props}>
      {children ?? label}
    </div>
  );
};
